import { ApolloClient, InMemoryCache, HttpLink, from } from "@apollo/client"
import { GRAPH_URL } from "../../../constants"
import AuthenticationUtil from "./AuthenticationUtil"
import fetch from "unfetch"

const httpLink = new HttpLink({
  uri: GRAPH_URL,
  fetch,
})

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: from([AuthenticationUtil.authTokensLink, httpLink]),
})

export default client
